// TODO: Is this the best place for the following type definition?
export type ExampleProgramPreview = {
  path: string;
  name: string;
  docMarkdown: string;
};

export const kSkulptGgbModuleUrl = "skulpt-ggb.js";
